import { lazy } from 'react';
import withSuspense from '../../../../../helpers/withSuspense.jsx';
import DynamicSkeletonGrid from '../../../../../skeleton_loaders/common/DynamicSkeletonGrid.jsx';

const ChartOptionsSettings = withSuspense(lazy(() => import('./ChartOptionsSettings.jsx')), <DynamicSkeletonGrid margin='2rem 0' gap='2rem' rowSizes={Array(8).fill(35)} colSizes={['100%']} />);

export default ChartOptionsSettings;